import React, { useEffect, useState } from "react";
import Pagetitle from '../../common/Pagetitle';
import ProductTab from './ProductTab';
//import PosCalculator from './PosCalculator';
import api from 'api';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { API } from "common/config-api"; // jsconfig.json

const ProductRegist = () => {

  const apiUrl = `${API.BASE_URL}`;

  const {productCode} = useParams();
  console.log("idx", productCode);

  const navigate = useNavigate();

  const [product, setProduct] = useState({
    productIdx: 0,
    productCode: "",
    productName: "",
    productManufacture: 0,
    productManufactureNickname: "",
    productPrice: 0,
    productDuty: "duty",
    productPoint: 0,
    productPriceBuyout: 0,
    productCategory: "conversion",
    productType: "dealer",
    productStatus: "instock",
    productCreatedate: "",
    productInventoryIdx: 0,
    productInventoryBlock: "",
    productInventoryRow: 0
  });


  const onChange = (event) => {
    const { value, name } = event.target; //event.target에서 name과 value만 가져오기
    console.log('value: ' + value + ', name: ' + [name]);
    //console.log(product);
    setProduct({
      ...product,
      [name]: value,
    });
  };

  const getProduct = async () => {
    try {
      const response = await api.get(apiUrl + '/product/' + productCode);
      const resp = response;
      console.log("product", resp);
      setProduct(resp);
    } catch (error) {
      console.error('상품 정보 조회 실패:', error);
      alert('상품 정보 조회 중 오류가 발생했습니다.');
    }
  };

  const saveProduct = async () => {
    console.log("product", product);
    try {
      const response = await api.post(apiUrl + '/product/regist', product);
      console.log(product);
      alert('적용되었습니다.');
      navigate('/product/list');
    } catch (error) {
      console.error('상품 저장 실패:', error);
      alert('상품 저장 중 오류가 발생했습니다.');
    }
  };

  const [dealerList, setDealerList] = useState([]);

  const getDealerList = async () => {
    try {
      const response = await api.get(apiUrl + '/user/dealer?page=1&size=100');
      const resp = response;
      // Page<> 응답에서 content 추출
      setDealerList(resp?.content || []);
    } catch (error) {
      console.error('딜러 목록 조회 실패:', error);
      alert('딜러 목록 조회 중 오류가 발생했습니다.');
    }
  };

  const blockArr = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];
  const inventoryBlock = () => {
    const inventoryBlockArr = [];
    for (let j=0; j < blockArr.length; j++) {
      inventoryBlockArr.push(<option key={blockArr[j]} value={blockArr[j]}>BLOCK {blockArr[j]}</option>);
    }
    return inventoryBlockArr;
  };

  const inventoryRow = () => {
    const inventoryRowArr = [];
    for (let i=1; i < 50; i++) {
      inventoryRowArr.push(<option key={i} value={i}>ROW {i}</option>);
    }
    return inventoryRowArr;
  };


  useEffect(() => {
    getProduct();
    getDealerList();
  }, []);

    return(

          <div className="row">
  
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">product Info.</h5>
  
  
                  <div className="row mb-3">
                    <label className="col-sm-2 col-form-label" data-bs-toggle="tooltip" data-bs-placement="top" title="고유번호">固有番号</label>
                    <label className="col-sm-2 col-form-label">{product.productIdx}</label>
                    <div className="col-sm-4">
                      <button type="button" className="btn btn-primary" onClick={saveProduct}>入力(及び修正)</button>
                    </div>
                  </div>

                  <div className="row mb-3">
                    <label className="col-sm-2 col-form-label" data-bs-toggle="tooltip" data-bs-placement="top" title="바코드">バーコード<code>*</code></label>
                    <div className="col-sm-10">
                      <input type="text" className="form-control" name="productCode" onChange={onChange} defaultValue={product.productCode} />
                    </div>
                  </div>

                  <div className="row mb-3">
                    <label className="col-sm-2 col-form-label" data-bs-toggle="tooltip" data-bs-placement="top" title="상품명">商品名<code>*</code></label>
                    <div className="col-sm-10">
                      <input type="text" className="form-control" name="productName" onChange={onChange} defaultValue={product.productName} />
                    </div>
                  </div>

                  <div className="row mb-3">
                    <label className="col-sm-2 col-form-label" data-bs-toggle="tooltip" data-bs-placement="top" title="딜러(제조사)">ディーラー(メーカー)</label>
                    <div className="col-sm-10">
                      <input 
                        type="text" 
                        className="form-control"
                        name="productManufactureNickname"
                        onChange={onChange}
                        list="dealerList"
                        defaultValue={product.productManufactureNickname} />
                    <datalist id="dealerList">
                    {dealerList.map((dealer) => <option key={dealer.userNickname} value={dealer.userNickname} />)}
                    </datalist>

                    </div>
                  </div>


                  <div className="row mb-3">
                    <label className="col-sm-2 col-form-label" data-bs-toggle="tooltip" data-bs-placement="top" title="판매금액">商品単価<code>*</code></label>
                    <div className="col-sm-3">
                    <input type="number" className="form-control" name="productPrice" onChange={onChange} value={product.productPrice ?? 0} />
                    </div>
                    <div className="col-sm-3">
                      <select className="form-select" aria-label="Default select example" name="productDuty" key={product.productDuty} onChange={onChange} defaultValue={product.productDuty}>
                        <option value="duty">부가세 포함</option>
                        <option value="nonduty">세금별도</option>
                        <option value="dutyfree">비과세</option>
                      </select>
                    </div>

                  </div>

                  <div className="row mb-3">
                    <label className="col-sm-2 col-form-label" data-bs-toggle="tooltip" data-bs-placement="top" title="필요포인트">ポイント</label>
                    <div className="col-sm-3">
                      <input type="number" className="form-control" name="productPoint" onChange={onChange} value={product.productPoint ?? 0} />
                    </div>
                    <div className="col-sm-6">
                      ※ 0 이상일 경우 포인트 없이 구매 불가
                    </div>  
                  </div>

                  <div className="row mb-3">
                    <label className="col-sm-2 col-form-label" data-bs-toggle="tooltip" data-bs-placement="top" title="상품구분">商品区分</label>
                    <div className="col-sm-3">
                      <select className="form-select" aria-label="Default select example" name="productType" key={product.productType} onChange={onChange} defaultValue={product.productType}>
                        <option value="dealer">딜러 위탁</option>
                        <option value="income">사입</option>
                        <option value="used">중고매입</option>
                        <option value="original">매장 자체상품</option>
                        <option value="etc">기타</option>
                      </select>
                    </div>
                    <div className="col-sm-3">
                      <select className="form-select" aria-label="Default select example" name="productCategory" key={product.productCategory} onChange={onChange} defaultValue={product.productCategory}>
                        <option value="accessary">accessary</option>
                        <option value="conversion">conversion parts</option>
                        <option value="figure">figure</option>
                        <option value="decal">decal</option>
                        <option value="sticker">sticker</option>
                        <option value="card">card</option>
                        <option value="etc">etc</option>
                      </select>
                    </div>
                  </div>
 
 
                  <div className="row mb-3">
                    <label className="col-sm-2 col-form-label" data-bs-toggle="tooltip" data-bs-placement="top" title="상품상태">商品状態</label>
                    <div className="col-sm-3">
                      <select className="form-select" name="productStatus" key={product.productStatus} onChange={onChange} defaultValue={product.productStatus}>
                        <option value="instock">販売中</option>
                        <option value="soldout">品切れ</option>
                        <option value="retired">断種</option>
                        <option value="hold">保留</option>
                        <option value="end">取り扱い終了</option>
                      </select>
                    </div>   
                  </div>

                  <div className="row mb-3">
                    <label className="col-sm-2 col-form-label" data-bs-toggle="tooltip" data-bs-placement="top" title="정산/매입가">原価/買入価格</label>
                    <div className="col-sm-10">
                    <input type="number" className="form-control" name="productPriceBuyout" onChange={onChange} value={product.productPriceBuyout ?? 0} />
                    </div>                  
                  </div>
           
                  <div className="row mb-3">
                    <label className="col-sm-2 col-form-label" data-bs-toggle="tooltip" data-bs-placement="top" title="재고위치/상태">在庫位置/状態</label>
                    <div className="col-sm-3">
                      <select className="form-select" aria-label="Default select example" name="productInventoryBlock" key={product.productInventoryBlock} onChange={onChange} defaultValue={product.productInventoryBlock}>
                        <option value="">-</option>
                        {inventoryBlock()}
                      </select>
                    </div>
                    <div className="col-sm-3">
                      <select className="form-select" name="productInventoryRow" key={product.productInventoryRow} onChange={onChange} defaultValue={product.productInventoryRow}>
                        <option value="0">-</option>
                        {inventoryRow()}
                      </select>
                    </div>
                 
                  </div>



                  {/*<div className="row mb-3">
                    <label className="col-sm-2 col-form-label">tag</label>
                    <div className="col-sm-4">
                      <input type="text" className="form-control" name={productTag} defaultValue={''}  />
                    </div>
                    <div className="col-sm-2">
                      <button type="button" className="btn btn-primary">add tag</button>
                    </div>
                  </div>
  
                  <div className="row mb-3">
                    <label className="col-sm-2 col-form-label"></label>
                    <div className="col-sm-10">
  
                      <button type="button" className="btn btn-light mb-2">
                        tag11 <span className="badge bg-secondary text-light" onClick={tempClick}>X</span>
                      </button>
  
                      <button type="button" className="btn btn-light mb-2">
                        tag22 <span className="badge bg-secondary text-light" onClick={tempClick}>X</span>
                      </button>
  
                      <button type="button" className="btn btn-light mb-2">
                        tag33 <span className="badge bg-secondary text-light" onClick={tempClick}>X</span>
                      </button>
  
                    </div>
                  </div>*/}
  
  

  
  
  
              </div>
            </div>
  

  
            {product.productCode ? <ProductTab idx={product.idx} /> : null}
    
  
          </div>



    );
}

export default ProductRegist;